export const Administrador = 10;
export const Atendente = 20;
export const Consultor = 30;
export const Criacao = 40;
export const GerenteComercial = 45;
export const Interno = 50;
export const Supervisor = 60;
export const TradeAdm = 70;
export const Comunicacao = 80;


// WEBPACK FOOTER //
// ./src/config/UserStatusLevel.js